const GA_MEASUREMENT_ID = import.meta.env.REACT_APP_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

const isGaAvailable = () => {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID) {
    return false;
  }
  
  // Check that gtag exists and is a real function, not a stub from an ad blocker
  if (typeof window.gtag !== "function") {
    return false;
  }
  
  // Check that this is not a stub from uBlock/AdBlock
  // Real gtag works with dataLayer, stubs usually have a different structure
  const gtagString = window.gtag.toString();
  const isRealGtag = gtagString.includes('dataLayer') || 
                     gtagString.length > 50; // Stubs are usually shorter
  
  if (!isRealGtag && import.meta.env.DEV) {
    console.warn('[GA4] ⚠️ Possible ad blocker stub detected');
    console.warn('[GA4] window.gtag appears to be a stub. Disable ad blocker (uBlock, AdBlock) for testing.');
  }
  
  return isRealGtag;
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (!isGaAvailable()) {
    if (import.meta.env.DEV) {
      console.log('[GA4] Event not sent:', eventName, params);
    }
    return;
  }
  
  try {
    window.gtag!("event", eventName, params || {});
    if (import.meta.env.DEV) {
      console.log('[GA4] Event sent:', eventName, params);
    }
  } catch (error) {
    console.error('[GA4] Error sending event:', eventName, error);
  }
};

/**
 * Sends a page_view event for the current page
 * Used during navigation in SPA
 */
export const trackPageView = (path?: string) => {
  if (!isGaAvailable()) {
    return;
  }
  
  const pagePath = path || (typeof window !== "undefined" ? window.location.pathname + window.location.search : '/');
  
  try {
    window.gtag!("event", "page_view", {
      page_path: pagePath,
      page_title: typeof document !== "undefined" ? document.title : '',
    });
    if (import.meta.env.DEV) {
      console.log('[GA4] page_view sent:', pagePath);
    }
  } catch (error) {
    console.error('[GA4] Error sending page_view:', error);
  }
};

// Business-level goals

export const trackVisitAgentsPage = () =>
  trackEvent("visitAgentsPage");

export const trackOpenRegisterPageAfterVisitHome = () =>
  trackEvent("openRegisterPageAfterVisitHome");

export const trackRegistrationSuccess = () =>
  trackEvent("registrationSuccess");

export const trackOperatorRegistered = () =>
  trackEvent("operatorRegistered");

export const trackBrokerRegistered = () =>
  trackEvent("brokerRegistered");

export const trackOperatorLoggedIn = () =>
  trackEvent("operatorLoggedIn");

export const trackBrokerLoggedIn = () =>
  trackEvent("brokerLoggedIn");

export const trackPlaneCreated = () =>
  trackEvent("planeCreated");

export const trackRegisterFormTouched = () =>
  trackEvent("registerFormTouched");

export const trackRegisterFormRequestSent = () =>
  trackEvent("registerFormRequestSent");

export const trackOrderRequestMakeOffer = () =>
  trackEvent("orderRequestMakeOffer");

export const trackOrderCreated = () =>
  trackEvent("orderCreated");

export const trackSearchEmptyLegs = () =>
  trackEvent("searchEmptyLegs");

export const trackCreateEmptyLegOrder = () =>
  trackEvent("createEmptyLegOrder");


